import { Component, Inject, ViewChild, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogBase, ObjectTypeClassInfo, SafetyCheckQuestionInfo} from 't4core';
import { CreateObjectTypeClassDialog } from '../CreateObjectTypeClassDialog/CreateObjectTypeClassDialog';
import { T4TranslationEditorComponent } from '../../../../t4common/components/t4-translation-editor/t4-translation-editor.component';
import { FormGroup, FormControl } from '@angular/forms';
import { Validators } from 'ngx-editor';

@Component({
  styleUrls: ['SafetyCheckQuestionDialog.css'],
  selector: 'SafetyCheckQuestionDialog',
  templateUrl: 'SafetyCheckQuestionDialog.html',
})
export class SafetyCheckQuestionDialog extends DialogBase implements OnInit {

  public objectTypeClasses: ObjectTypeClassInfo[] = [];
  public safetyCheckQusetions: SafetyCheckQuestionInfo;
  public translationKey: string = '';

  @ViewChildren(T4TranslationEditorComponent) translationEditors: QueryList<T4TranslationEditorComponent>;
  constructor(
    public dialogRef: MatDialogRef<CreateObjectTypeClassDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super("SafetyCheckQuestionDialog");
  }
  public async ngOnInit() {
    console.log("safety", this.data);
    this.safetyCheckQusetions = new SafetyCheckQuestionInfo();
    if (this.data.safetyCheckQuestionData) {
      this.safetyCheckQusetions = this.data.safetyCheckQuestionData
    }

  }

  public async getObjectClassesBySafetyCheckQ() {
    var token = this.UI.beginLoading("T4.Settings.SafetyCheckQuestionDialog.msgLoading", "Loading Object Type Class", null);
    this.objectTypeClasses = await this.Api.get<ObjectTypeClassInfo[]>("Settings/GetObjectTypeClassesBySafetyQueId", { QuesId: this.data.safetyCheckQuestionData.Id });
    this.UI.loaderCompleted(token);
  }

  public async save() {
    this.safetyCheckQusetions.Name = `T4.Data.SafetyCheckQuestion.${this.data.typeClassId}.${this.safetyCheckQusetions.Key}.Name`;
    this.safetyCheckQusetions.TypeClassId = this.data.typeClassId;

    //Save the translation editors.
    await this.translationEditors.forEach(tb => tb.saveTranslations());
    var token = this.UI.beginLoading("T4.Settings.PhotoAngleDialog.msgCreatingSCQ", "Creating new safety check questions", null);
    var res = await this.Api.post<boolean>("Settings/SaveSafetyCheckQuestions", this.safetyCheckQusetions);

    this.UI.loaderCompleted(token);
    this.dialogRef.close();
  }
  onKeyBlur(): void {
    const keyValue = this.safetyCheckQusetions.Key;
    if (keyValue) {
      this.translationKey = `T4.Data.SafetyCheckQuestion.${this.data.typeClassId}.${keyValue}.Name`; 
    } else {
      this.translationKey = '';
    }
  }
}
